module.exports = __webpack_public_path__ + "img/heroPic.386faca7.jpg";